module.exports = __webpack_public_path__ + "static/media/PhpLogo.b9ed1bea.png";